import { getKwpAccessToken } from '../helpers';

export const transformCustomersForSaving = (customers: any[], companyId: string | undefined) => {
  const transformed: any = [];

  if (Array.isArray(customers)) {
    customers.forEach(customer => {
      const email =
        customer.kontakte &&
        customer.kontakte.find((record: any) => record.kontakt && record.kontakt.includes('@'));

      transformed.push({
        customerName: `${customer.vorname || ''} ${customer.name || ''}`,
        salutation:
          (customer.anrede &&
            (customer.anrede.anrede === 'Firma'
              ? 'COMPANY'
              : customer.anrede.anrede === 'Herr'
              ? 'MR'
              : 'MS')) ||
          'MR',
        email: (email && email.kontakt) || null,
        ...(customer.anrede &&
          customer.anrede.anrede === 'Firma' && { companyName: customer.zusatz || '' }),
        companyId,
      });
    });
  }

  return transformed;
};

export const transformProjectsForSaving = (
  projects: any[],
  ganttId: string | undefined,
  currentMemberId: string | undefined,
  currentCompanyId: string | undefined,
  userLink: string | undefined
) => {
  const token = getKwpAccessToken();
  const transformed: any = [];

  if (Array.isArray(projects)) {
    projects.forEach(project => {
      transformed.push({
        projectNumber: project.projNr || null,
        name: project.projBezeichnung || 'defaultName',
        startDate: project.beginn ? new Date(project.beginn) : new Date(),
        customerName: `${project.adresse.vorname || ''} ${project.adresse.name || ''}`,
        address: {
          street: project.adresse.strasse || '',
        },
        ownerMemberId: currentMemberId,
        ganttIds: [ganttId],
        companyId: currentCompanyId,
        customerAddressCode: project.adresse.adrNrGes,
        userLink,
        token,
      });
    });
  }

  return transformed;
};
